import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { ButtonSize, ButtonStyle, ButtonType, ButtonColors } from '../shared/components/inputs/button/button.model';
import { RegisterModel } from '../register/register.model';
import { Constants } from '../shared/constants';
import { HttpHeaders } from '@angular/common/http';
import { NotificationService } from '../shared/services/notifications.service';
import { AuthService } from '../auth/auth.service';
import { OrganizationModel } from '../admin/models/organization.model';
import { forkJoin } from 'rxjs';
import { UserGroupModel } from '../admin/models/group.model';
import forge from 'node-forge';
import { CognitoService, ICognitoUser } from '../shared/services/cognito.service';

@Component({
  selector: 'app-register', 
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  standalone: false
})

export class RegisterComponent implements OnInit {

  //, private router: Router

  cognitoUser: ICognitoUser;
  userCreatedInDb: boolean = false;

  constructor(private baseHttpService: BaseHttpService, private router: Router, private notificationService: NotificationService, private authService: AuthService
    , private cognitoService: CognitoService
  ) {


    this.cognitoUser = {} as ICognitoUser;
  }


  ngOnInit() {
    
    const orgs$ = this.baseHttpService.get(this.constant.getAllOrgsdet);

    forkJoin([orgs$]).subscribe(results => {

      this.masterOrgs = results[0];
    });

    if (this.authService.isTokenValid()) {
      this.router.navigate(["/dashboard"]);
      return;
    }
  }

  masterOrgs: OrganizationModel[] = [];
  RegistrationHeading: string = "CREATE ACCOUNT";
  ConfirmPassword: string;
  OrganizationId: string;
  //gconfig$ = this.store.pipe(select(selectUser));
  //gconfigWaiting$ = this.store.pipe(select(selectIsWaiting));
  isMultiLine = true;
  regbtnText = "CREATE ACCOUNT";
  btnXlarge = ButtonSize.Xlarge;
  btnWithText = ButtonStyle.Textonly;
  btnRect = ButtonType.Rectangle;
  btnWhite = ButtonColors.White;
  signinbtnText = "SIGN IN";

  useraddedToPool :boolean = false;


  constant: Constants = new Constants();
  register: RegisterModel = {
    firstname: null,
    lastname: null,
    email: null,
    password: null,
    location: null,
    organizationId: null,
    url:null

  }

  SelectOrg(val: any) {
    this.register.organizationId = val;
  }

  registerform(form: NgForm) {
    
    if (this.register.firstname == "" || this.register.firstname == null || this.register.lastname == null || this.register.lastname == ""
      || this.register.email == null || this.register.email == "" || this.register.password == null || this.register.password == ""
      || this.ConfirmPassword == null || this.ConfirmPassword == "" || this.register.organizationId == null || this.register.organizationId == "") {
      this.notificationService.showError("Please enter all fields", "Error");
      return;
    }
    if (this.register.password != this.ConfirmPassword) {
      this.notificationService.showError("Confirm Password must be same as Password", "Error");
      return;
    }
    if(!this.register.email.match(this.constant.emailRegex)){
      this.notificationService.showError("Enter email in correct format", "Error");
      return;
    }
    if (!this.register.password.match(this.constant.pwdRegex)) {
      this.notificationService.showError("Password should be at least 8 characters long and should contain one number,one character and one special character($,@,!,%,*,#,?,&)", "Error");
      return
    }
   
    let rsa = forge.pki.publicKeyFromPem(this.constant.publicKey);
    //     let encryptedPwd = window.btoa(rsa.encrypt(this.register.password));
    // let encryptedEmail = window.btoa(rsa.encrypt(this.register.email));
    let encryptedPwd = window.btoa(
      rsa.encrypt(this.register.password, 'RSA-OAEP', {
        md: forge.md.sha1.create()
      }))
    let encryptedEmail = window.btoa(
      rsa.encrypt(this.register.email, 'RSA-OAEP', {
        md: forge.md.sha1.create()
      }))
    this.register.password = encryptedPwd;
    this.register.email = encryptedEmail;
    this.baseHttpService.post(this.constant.accountRegistration, this.register).subscribe((result) => {
      if (!result.success) {
        this.notificationService.showError("Entered email id already exists!", "Registration failed!");
      }
      else {
        this.notificationService.showSuccess("Your account creation was successful! You may login now.", "Registration successful!");
        this.mapGroup();
        form.reset();
        this.router.navigate([""]);
      }
    });
  }

  mapGroup() {
    let user = new UserGroupModel();
    user.email = this.register.email;
    user.organizationId = this.register.organizationId;
    this.baseHttpService.post(this.constant.updateDefaultUserRole, user);
  }

  Navigate() {
    this.router.navigate(['/', 'login']);

  }
  //document.getElementById('id01').style.display = 'block' 









  awsCognitoSignUp(form: NgForm){
    //debugger;
    if (this.register.firstname == "" || this.register.firstname == null || this.register.lastname == null || this.register.lastname == ""
      || this.register.email == null || this.register.email == "" || this.register.password == null || this.register.password == ""
      || this.ConfirmPassword == null || this.ConfirmPassword == "" || this.register.organizationId == null || this.register.organizationId == "") {
      this.notificationService.showError("Please Enter All Fields", "Error");
      return;
    }
    if (this.register.password != this.ConfirmPassword) {
      this.notificationService.showError("Confirm Password must be same as Password", "Error");
      return;
    }
    if(!this.register.email.match(this.constant.emailRegex)){
      this.notificationService.showError("Enter email in correct format", "Error");
      return;
    }
    if (!this.register.password.match(this.constant.pwdRegex)) {
      this.notificationService.showError("Password should be at least 8 characters long and should contain one number,one character and one special character($,@,!,%,*,#,?,&)", "Error");
      return
    }


    this.cognitoUser.email = this.register.email;
    this.cognitoUser.password = this.register.password;
    //add user to cognito pool in aws
    this.signUp(form);
   
    // this.addCognitoUserToDb();
  }


  addCognitoUserToDb(form :NgForm) {
    let rsa = forge.pki.publicKeyFromPem(this.constant.publicKey);

    let pwd = this.register.password;
    let email = this.register.email;
    // let encryptedPwd = window.btoa(rsa.encrypt(pwd));
    // let encryptedEmail = window.btoa(rsa.encrypt(email));    
    let encryptedPwd = window.btoa(
      rsa.encrypt(this.register.password, 'RSA-OAEP', {
        md: forge.md.sha1.create()
      }))
    let encryptedEmail = window.btoa(
      rsa.encrypt(this.register.email, 'RSA-OAEP', {
        md: forge.md.sha1.create()
      }))
     // Create a new object for the API call to avoid mutating the original register object
     let registerapiObj = new RegisterModel();
     registerapiObj = { ...this.register, password: encryptedPwd, email: encryptedEmail };
     

    this.baseHttpService.post(this.constant.accountRegistration, registerapiObj).subscribe((result) => {
      if (!result.success) {
        //this.notificationService.showError("Entered Email Id already exists!", "Registration Failed!");
      }
      else {
        //this.notificationService.showSuccess("Your account creation was successful! You may login now.", "Registration Successful!");
        this.mapGroup();
        form.reset();
        this.router.navigate([""]);
      }

      if(this.useraddedToPool){
        this.notificationService.showSuccess("Your account creation was successful! You may login now.", "Registration Successful!");
      }         
    });
  }


  public signUp(form :NgForm) {   
    this.useraddedToPool = false;
    this.cognitoService.signUp(this.cognitoUser)
    .then(() => {
      console.log("User added to Cognito User pool successfully."); 
      this.useraddedToPool = true;
      //add user to data base customer table only      
      this.addCognitoUserToDb(form);
    }).catch((error) => {
      this.notificationService.showError(error.message.toString(), "Registration Failure!");
    });
  }

  // public confirmSignUp(): void {
  //   debugger;
  //   this.loading = true;
  //   this.cognitoService.confirmSignUp(this.cognitoUser)
  //   .then(() => {
  //     this.router.navigate(['/signIn']);
  //   }).catch(() => {
  //     this.loading = false;
  //   });
  // }

}
